import React from "react";
import {
  t,
  HS_TITLE,
  HS_P1,
  HS_P2,
  HS_P3,
  GAPK_TITLE,
  GAPK_P1,
  BOK_TITLE,
  BOK_P1,
  BOK_P2,
  RSO_TITLE,
  PS_TITLE,
  PS_P1,
} from "../../translations/AboutUs/History";

function History() {
  return (
    <div
      className="a-normal"
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HS_TITLE)}
      </div>
      <div
        className="a-regular"
        style={{
          fontWeight: 400,
          color: "#444444",
          textAlign: "justify",
          paddingBottom: 15,
        }}
      >
        {t(HS_P1)}
        <br />
        <br />
        {t(HS_P2)}
        <br />
        <br />
        {t(HS_P3)}
      </div>
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(GAPK_TITLE)}
      </div>
      <div
        className="a-regular"
        style={{
          fontWeight: 400,
          color: "#444444",
          textAlign: "justify",
          paddingBottom: 15,
        }}
      >
        {t(GAPK_P1)}
      </div>
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(BOK_TITLE)}
      </div>
      <div
        className="a-regular"
        style={{
          fontWeight: 400,
          color: "#444444",
          textAlign: "justify",
          paddingBottom: 15,
        }}
      >
        {t(BOK_P1)}
        <br />
        <br />
        {t(BOK_P2)}
      </div>
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(RSO_TITLE)}
      </div>
      <div>
        <img src="/image/ksrtc_history_new.png" alt="" />
      </div>
      <div className="a-large" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(PS_TITLE)}
      </div>
      <div
        className="a-regular"
        style={{
          fontWeight: 400,
          color: "#444444",
          textAlign: "justify",
        }}
      >
        {t(PS_P1)}
      </div>
    </div>
  );
}

export default History;
